import type { Dispatch } from 'redux'
import history from '@chegg-wt/core-wa/utils/history/history'
import getFeatureEditor from '@chegg-wt/core-wa/utils/getEditor'
import { GrammarFeedback, ParaphraseFeedback } from '@chegg-wt/core-wa/types'
import { ProofReaderCardActions, SentenceOffset } from '@chegg-wt/core-wa/state/types'
import { deleteFeedback } from '@chegg-wt/core-wa/state/actions'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { getFeedbackPosition } from '@chegg-wt/core-wa/utils/helpers'
import { HistoryDeltaAction } from '@chegg-wt/core-wa/utils/history/types'
import { debounceOnSavePaper } from '@chegg-wt/core-wa/state/utils'
import { setNextCardActiveAfterDeleteOrUpdate } from './utils'

export const handleFeedbackCardDeleteClick = (
  feedbackId: string,
  deletingFeedbackIndex: number,
  feedbacks: GrammarFeedback[] | ParaphraseFeedback[],
  sentenceOffsets: SentenceOffset[],
  dispatch: Dispatch,
  setActiveCard: (cardId: string) => void,
  isFlagged?: boolean
): void => {
  const editor = getFeatureEditor()
  const feedbackToRemove = feedbacks[deletingFeedbackIndex]

  const { impactedText, ...feedback } = feedbackToRemove
  const { id, suggestedText } = feedback

  // Add discard card change to history and commit
  history.addFeedbackChange(
    {
      feedback,
      action: HistoryDeltaAction.DISCARD,
    },
    isFlagged
  )
  history.commit()

  dispatch(
    userClick({
      origin: origins.proofReaderFeedbackCardClick,
      text: impactedText,
      value: suggestedText,
      id,
      citationMetadata: {
        proofReaderCardtype: feedbackToRemove.feedbackType,
        proofReaderCardAction: ProofReaderCardActions.REJECT,
      },
    })
  )

  const { offset, length } = getFeedbackPosition(feedbackToRemove, sentenceOffsets)

  const { from, to } = editor.state.selection

  editor.commands.removeCustomUnderline({
    id: feedbackId,
    offset,
    length,
  })

  editor.commands.setTextSelection({ from, to })

  dispatch(deleteFeedback(feedbackId))

  setNextCardActiveAfterDeleteOrUpdate(deletingFeedbackIndex, feedbacks, setActiveCard)
  debounceOnSavePaper(dispatch) // As there is no text change we need to handle saving delete case specially
}
